/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputMissionDropData
 */
export interface OutputMissionDropData {
    /**
     * 
     * @type {string}
     * @memberof OutputMissionDropData
     */
    customTarget?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionDropData
     */
    customTargetType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputMissionDropData
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputMissionDropData
     */
    sequenceNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputMissionDropData
     */
    stockAmmoId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionDropData
     */
    stockAmmoName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionDropData
     */
    targetCoords?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputMissionDropData
     */
    targetId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionDropData
     */
    targetStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputMissionDropData
     */
    targetTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionDropData
     */
    targetTypeName?: string;
}

/**
 * Check if a given object implements the OutputMissionDropData interface.
 */
export function instanceOfOutputMissionDropData(value: object): boolean {
    return true;
}

export function OutputMissionDropDataFromJSON(json: any): OutputMissionDropData {
    return OutputMissionDropDataFromJSONTyped(json, false);
}

export function OutputMissionDropDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputMissionDropData {
    if (json == null) {
        return json;
    }
    return {
        
        'customTarget': json['customTarget'] == null ? undefined : json['customTarget'],
        'customTargetType': json['customTargetType'] == null ? undefined : json['customTargetType'],
        'id': json['id'] == null ? undefined : json['id'],
        'sequenceNumber': json['sequenceNumber'] == null ? undefined : json['sequenceNumber'],
        'stockAmmoId': json['stockAmmoId'] == null ? undefined : json['stockAmmoId'],
        'stockAmmoName': json['stockAmmoName'] == null ? undefined : json['stockAmmoName'],
        'targetCoords': json['targetCoords'] == null ? undefined : json['targetCoords'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'targetStatus': json['targetStatus'] == null ? undefined : json['targetStatus'],
        'targetTypeId': json['targetTypeId'] == null ? undefined : json['targetTypeId'],
        'targetTypeName': json['targetTypeName'] == null ? undefined : json['targetTypeName'],
    };
}

export function OutputMissionDropDataToJSON(value?: OutputMissionDropData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customTarget': value['customTarget'],
        'customTargetType': value['customTargetType'],
        'id': value['id'],
        'sequenceNumber': value['sequenceNumber'],
        'stockAmmoId': value['stockAmmoId'],
        'stockAmmoName': value['stockAmmoName'],
        'targetCoords': value['targetCoords'],
        'targetId': value['targetId'],
        'targetStatus': value['targetStatus'],
        'targetTypeId': value['targetTypeId'],
        'targetTypeName': value['targetTypeName'],
    };
}

